var map = {
	"./app_strings.json": 43321,
	"./client/account_client.json": 66255,
	"./client/common_client.json": 4229,
	"./client/console.json": 36524,
	"./client/consultation_client.json": 33368,
	"./client/eyes.json": 59193,
	"./client/nav_client.json": 98133,
	"./client/patient_client.json": 56433,
	"./client/pdf.json": 59352,
	"./client/stats_client.json": 46025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5182;